/* nav-brands-2026-11-03 — NUBO unter Aromen + Nikotinsalz (vorher: 2026-09-03 restore Aromen) */
/**
 * Lynden Hardware v2 DEV — mockup header chrome
 * ONLY on unpublished preview theme (loaded from DEV theme.liquid).
 *
 * Hides Impact announcement / header / theme-breadcrumb and injects:
 *   1) static trustbar
 *   2) mockup header (logo, centered nav + dropdowns, icons)
 *   3) mobile drawer with accordion sub-categories
 */
(function () {
  var MARK = "lyd-hv2-chrome";
  var ROOT_ID = "lyd-hv2-chrome-root";
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 160;

  /**
   * Top-level nav + sub-categories.
   * Intentionally curated brand/type pages (not every SEO/leaf collection —
   * e.g. skips "10ml Liquids>…>…" auto-handles). Expand when new brands launch.
   */
  /* nav-brands-2026-08-26 */
var NAV = [
    {
      label: "E-Zigaretten",
      href: "/collections/e-zigaretten",
      children: [
        { label: "Alle E-Zigaretten", href: "/collections/e-zigaretten", all: true },
        { label: "Lynden", href: "/collections/lynden-e-zigaretten" },
        { label: "Uwell", href: "/collections/uwell-e-zigaretten" },
        { label: "Geekvape", href: "/collections/geekvape-e-zigaretten" },
        { label: "Vaporesso", href: "/collections/vaporesso-e-zigaretten" },
        { label: "Elfbar", href: "/collections/elfbar-e-zigaretten" },
        { label: "Flerbar", href: "/collections/flerbar-e-zigaretten" },
        { label: "GOBAR", href: "/collections/e-zigaretten-gobar" },
        { label: "Joyetech", href: "/collections/e-zigaretten-joyetech" },
        { label: "Justfog", href: "/collections/justfog-e-zigaretten" },
        { label: "Lost Vape", href: "/collections/e-zigaretten-lost-vape" },
        { label: "SMOK", href: "/collections/e-zigaretten-smok" },
        { label: "SKE", href: "/collections/ske-e-zigaretten" },
        { label: "IVG", href: "/collections/ivg-e-zigaretten" },
        { label: "KTS", href: "/collections/kts-e-zigaretten" },
        { label: "Linvo", href: "/collections/linvo-e-zigaretten" },
        { label: "Innokin", href: "/collections/innokin-e-zigaretten" },
        { label: "eGo", href: "/collections/innocigs-e-zigaretten" },
        { label: "Einweg", href: "/collections/einweg-e-zigaretten" },
        { label: "Sale E-Zigaretten", href: "/collections/sale-e-zigaretten" },
      ],
    },
    {
      label: "Depots",
      href: "/collections/lynden-premium-depots",
      children: [
        { label: "Alle Depots", href: "/collections/lynden-premium-depots", all: true },
        { label: "Lynden Premium Depots", href: "/collections/lynden-premium-depots" },
      ],
    },
    {
      label: "Pods",
      href: "/collections/pods",
      children: [
        { label: "Alle Pods", href: "/collections/pods", all: true },
        { label: "Prefilled Pods", href: "/collections/prefilled-pods" },
        { label: "Leer-Pods", href: "/collections/leer-pods" },
        { label: "Caps & Pods", href: "/collections/caps-pods" },
        { label: "Elfbar Pods", href: "/collections/elfbar-pods" },
        { label: "Uwell Pods", href: "/collections/uwell-pods" },
        { label: "Geekvape Pods", href: "/collections/geekvape-pods" },
        { label: "Vaporesso Pods", href: "/collections/vaporesso-pods" },
        { label: "IVG Pods", href: "/collections/ivg-pods" },
        { label: "Justfog Pods", href: "/collections/justfog-pods" },
        { label: "Lost Vape Pods", href: "/collections/lost-vape-pods" },
        { label: "Joyetech Pods", href: "/collections/joyetech-pods" },
        { label: "SMOK Pods", href: "/collections/smok-pods" },
        { label: "Linvo Pods", href: "/collections/linvo-pods" },
        { label: "Innokin Pods", href: "/collections/innokin-pods" },
        { label: "Aspire Pods", href: "/collections/aspire-pods" },
        { label: "Flerbar Pods", href: "/collections/flerbar-pods" },
        { label: "SKE Pods", href: "/collections/ske-pods" },
      ],
    },
    {
      label: "Liquids",
      href: "/collections/liquids",
      children: [
        { label: "Alle Liquids", href: "/collections/liquids", all: true },
        {
          label: "Liquid Finder",
          href: "/pages/liquid-finder?system=dtl",
          tool: true,
        },
        { label: "Beliebteste", href: "/collections/die-beliebtesten-liquids" },
        { label: "Lynden Liquids", href: "/collections/lynden-liquids" },
        { label: "InnoCigs", href: "/collections/innocigs-liquids" },
        { label: "Vampire Vape", href: "/collections/vampire-vape-liquid" },
        { label: "SC Liquid", href: "/collections/sc-liquid" },
        { label: "FlavourArt", href: "/collections/flavourart-liquids" },
        { label: "Happy Liquid", href: "/collections/happy-liquid-liquids" },
        { label: "Das ist Dampfen", href: "/collections/das-ist-dampfen-liquids" },
        { label: "Vincent dans les Vapes", href: "/collections/vincent-dans-les-vapes-liquids" },
        { label: "Culami", href: "/collections/culami-liquids" },
        { label: "Cirkus", href: "/collections/cirkus-liquids" },
        { label: "Basis", href: "/collections/basis" },
      ],
    },
    {
      label: "Aromen",
      href: "/collections/aromen",
      children: [
        { label: "Alle Aromen", href: "/collections/aromen", all: true },
        { label: "5EL", href: "/collections/5el-longfill" },
        { label: "#Schmeckt", href: "/collections/schmeckt-longfill-aroma" },
        { label: "Big Bottle", href: "/collections/big-bottle-longfill" },
        { label: "Boss Juice", href: "/collections/boss-juice-longfill" },
        { label: "Vampire Vape", href: "/collections/vampire-vape-longfill" },
        { label: "Vampire Vape Overdosed", href: "/collections/vampire-vape-overdosed" },
        { label: "Vampire Vape Aroma 30 ml", href: "/collections/vampire-vape-aroma-30ml" },
        { label: "Vampire Vape Dessert", href: "/collections/vampire-vape-dessert-aroma" },
        { label: "Revoltage", href: "/collections/revoltage-longfill" },
        { label: "SC Red Line", href: "/collections/sc-red-line-longfill" },
        { label: "SC Aroma", href: "/collections/sc-aroma" },
        { label: "FlavourArt", href: "/collections/flavourart-aroma" },
        { label: "GangGang", href: "/collections/ganggang-aroma" },
        { label: "Nebelfee", href: "/collections/nebelfee-aroma" },
        { label: "Aroma Syndikat", href: "/collections/aroma-syndikat" },
        { label: "MaZa", href: "/collections/maza-longfill" },
        { label: "Kirschlolli", href: "/collections/kirschlolli-longfill" },
        { label: "Twelve Monkeys", href: "/collections/twelve-monkeys-longfill" },
        { label: "Bar Series", href: "/collections/bar-series-longfill" },
        { label: "Flavorist", href: "/collections/flavorist-longfill" },
        { label: "Must Have", href: "/collections/must-have-longfill" },
        { label: "Bad Candy Aroma", href: "/collections/bad-candy-aroma" },
        { label: "Bad Candy Juicd", href: "/collections/bad-candy-juicd-longfill" },
        { label: "Vagrand", href: "/collections/vagrand-longfill" },
        { label: "Montreal Original", href: "/collections/montreal-original-longfill" },
        { label: "Dr. Frost", href: "/collections/dr-frost-aroma" },
        { label: "NUBO", href: "/collections/nubo-longfill" },
        { label: "Mr. Mint", href: "/collections/mr-mint-longfill" },
        { label: "TNYVPS", href: "/collections/tnyvps-longfill" },
        { label: "Treibstoff", href: "/collections/treibstoff-longfill" },
        { label: "Monsoon", href: "/collections/monsoon-aroma" },
      ],
    },
    {
      label: "Nikotinsalz",
      href: "/collections/nikotinsalz-liquids",
      children: [
        { label: "Alle Nikotinsalz", href: "/collections/nikotinsalz-liquids", all: true },
        {
          label: "Liquid Finder",
          href: "/pages/liquid-finder?system=mtl",
          tool: true,
        },
        { label: "ELFLIQ", href: "/collections/elfbar-elfliq-nikotinsalz" },
        { label: "Pod Salt", href: "/collections/pod-salt-nikotinsalz" },
        { label: "SC Nikotinsalz", href: "/collections/sc-nikotinsalz" },
        { label: "Flerbar", href: "/collections/flerbar-nikotinsalz" },
        { label: "Elux", href: "/collections/elux-nikotinsalz" },
        { label: "Bad Candy", href: "/collections/bad-candy-nikotinsalz" },
        { label: "Revoltage", href: "/collections/revoltage-nikotinsalz" },
        { label: "Vampire Vape", href: "/collections/vampire-vape-nikotinsalz" },
        { label: "Dr. Frost", href: "/collections/dr-frost-nikotinsalze" },
        { label: "NUBO", href: "/collections/nubo-nikotinsalz" },
        { label: "Twelve Monkeys", href: "/collections/twelve-monkeys-nikotinsalz" },
        { label: "SIC! Salts", href: "/collections/sic-salts-nikotinsalz" },
        { label: "Big Bottle", href: "/collections/big-bottle-nikotinsalz" },
        { label: "Linvo", href: "/collections/linvo-nikotinsalz" },
        { label: "Montreal Original", href: "/collections/montreal-original-nikotinsalz" },
        { label: "Happy Liquid", href: "/collections/happy-liquid-nikotinsalz" },
        { label: "Das ist Dampfen", href: "/collections/das-ist-dampfen-nikotinsalz" },
        { label: "Salt Club", href: "/collections/salt-club-nikotinsalz" },
        { label: "Overvape", href: "/collections/overvape-nikotinsalz" },
        { label: "Ohm Brew", href: "/collections/ohm-brew-nikotinsalz" },
        { label: "Kirschlolli", href: "/collections/kirschlolli-nikotinsalz" },
        { label: "Nikotinshots", href: "/collections/nikotinshots" },
      ],
    },
    {
      label: "Zubehör",
      href: "/collections/zubehor",
      children: [
        { label: "Alles Zubehör", href: "/collections/zubehor", all: true },
        { label: "Lynden Zubehör", href: "/collections/lynden-zubehor" },
        { label: "Uwell Zubehör", href: "/collections/uwell-zubehoer" },
        { label: "Vaporesso Zubehör", href: "/collections/vaporesso-zubehor" },
        { label: "Justfog Zubehör", href: "/collections/justfog-zubehor" },
        { label: "IVG Zubehör", href: "/collections/ivg-zubehor" },
        { label: "Geekvape Zubehör", href: "/collections/geekvape-zubehor" },
        { label: "Lost Vape Zubehör", href: "/collections/lost-vape-zubehor" },
        { label: "Joyetech Zubehör", href: "/collections/joyetech-zubehor" },
        { label: "XTAR Zubehör", href: "/collections/xtar-zubehor" },
        { label: "SKE Zubehör", href: "/collections/ske-zubehor" },
        { label: "SC Zubehör", href: "/collections/sc-zubehor" },
        { label: "Sonstiges", href: "/collections/sonstiges-zubehor" },
        { label: "Sale Zubehör", href: "/collections/sale-zubehor" },
      ],
    },
    { label: "Angebote", href: "/collections/sale", sale: true },
  ];

  /**
   * Mobile quick category strip (chips under header).
   * Curated top destinations only — full tree stays in the drawer.
   */
  var MOBILE_QUICK_NAV = [
    { label: "E-Zigaretten", href: "/collections/e-zigaretten" },
    { label: "Liquids", href: "/collections/liquids" },
    { label: "Aromen", href: "/collections/aromen" },
    { label: "Nikotinsalz", href: "/collections/nikotinsalz-liquids" },
    { label: "Pods", href: "/collections/pods" },
    { label: "Depots", href: "/collections/lynden-premium-depots" },
    { label: "Zubehör", href: "/collections/zubehor" },
    { label: "Liquid Finder", href: "/pages/liquid-finder", tool: true },
    { label: "Sale", href: "/collections/sale", sale: true },
  ];

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function mark() {
    try {
      document.documentElement.classList.add(MARK);
      if (document.body) document.body.classList.add(MARK);
    } catch (e) {}
  }

  function hideImpactChrome() {
    var selectors = [
      ".shopify-section--announcement-bar",
      ".shopify-section--header",
      "#shopify-section-header",
      ".shopify-section-group-header-group.shopify-section--header",
      "store-header.header",
      ".shopify-section--breadcrumb",
      ".shopify-section-group-header-group.shopify-section--breadcrumb",
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty("display", "none", "important");
        el.setAttribute("aria-hidden", "true");
      });
    });
  }

  function svg(paths, extraClass) {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true"' +
      (extraClass ? ' class="' + extraClass + '"' : "") +
      ">" +
      paths +
      "</svg>"
    );
  }

  var LOGO_FALLBACK =
    "https://www.lynden.de/cdn/shop/files/00_Lynden_Logo_Black.png?v=1708944793&width=280";

  function resolveLogoSrc() {
    var img =
      document.querySelector(
        ".shopify-section--header .header__logo-image:not(.header__logo-image--transparent)"
      ) ||
      document.querySelector(
        "store-header .header__logo-image:not(.header__logo-image--transparent)"
      ) ||
      document.querySelector(".header__logo img") ||
      document.querySelector(
        'img[src*="Lynden_Logo"], img[src*="lynden_logo"], img[src*="Lynden_logo"]'
      );
    if (img) {
      var src =
        img.currentSrc ||
        img.getAttribute("src") ||
        img.getAttribute("data-src") ||
        "";
      if (src) {
        return src.replace(/&amp;/g, "&").replace(/width=\d+/i, "width=280");
      }
    }
    return LOGO_FALLBACK;
  }

  function logoHtml() {
    var src = resolveLogoSrc();
    return (
      '<a class="lyd-hv2-siteheader__logo" href="/" aria-label="LYNDEN Startseite">' +
      '<img class="lyd-hv2-siteheader__logo-img" src="' +
      src +
      '" alt="LYNDEN" width="140" height="40" decoding="async" />' +
      "</a>"
    );
  }

  function navItemHtml(item, idx) {
    var hasKids = item.children && item.children.length;
    var id = "lyd-hv2-nav-panel-" + idx;
    var linkClass =
      "lyd-hv2-siteheader__link" + (item.sale ? " is-sale" : "");
    var chev = hasKids
      ? svg('<path d="M6 9l6 6 6-6"/>', "lyd-hv2-siteheader__chev")
      : "";

    var top =
      '<a class="' +
      linkClass +
      '" href="' +
      item.href +
      '"' +
      (hasKids
        ? ' aria-haspopup="true" aria-expanded="false" aria-controls="' +
          id +
          '"'
        : "") +
      ">" +
      item.label +
      chev +
      "</a>";

    if (!hasKids) {
      return '<div class="lyd-hv2-siteheader__item">' + top + "</div>";
    }

    var mega = item.children.length > 10 ? " is-mega" : "";
    var panel =
      '<ul class="lyd-hv2-siteheader__panel' +
      mega +
      '" id="' +
      id +
      '" role="list">' +
      item.children
        .map(function (c) {
          var cls = [];
          if (c.all) cls.push("is-all");
          if (c.tool) cls.push("is-tool");
          return (
            "<li>" +
            '<a href="' +
            c.href +
            '"' +
            (cls.length ? ' class="' + cls.join(" ") + '"' : "") +
            ">" +
            c.label +
            "</a></li>"
          );
        })
        .join("") +
      "</ul>";

    return (
      '<div class="lyd-hv2-siteheader__item" data-has-panel>' +
      top +
      panel +
      "</div>"
    );
  }

  function drawerHtml() {
    var rows = NAV.map(function (item, idx) {
      var hasKids = item.children && item.children.length;
      var subId = "lyd-hv2-drawer-sub-" + idx;
      var linkClass = item.sale ? ' class="is-sale"' : "";
      var main =
        '<div class="lyd-hv2-drawer__row-main">' +
        '<a href="' +
        item.href +
        '"' +
        linkClass +
        ">" +
        item.label +
        "</a>";

      if (hasKids) {
        main +=
          '<button type="button" class="lyd-hv2-drawer__toggle" aria-expanded="false" aria-controls="' +
          subId +
          '" aria-label="' +
          item.label +
          ' Untermenü">' +
          svg('<path d="M6 9l6 6 6-6"/>') +
          "</button>";
      }
      main += "</div>";

      var subs = "";
      if (hasKids) {
        subs =
          '<ul class="lyd-hv2-drawer__subs" id="' +
          subId +
          '" hidden>' +
          item.children
            .map(function (c) {
              var cls = [];
              if (c.all) cls.push("is-all");
              if (c.tool) cls.push("is-tool");
              return (
                "<li>" +
                '<a href="' +
                c.href +
                '"' +
                (cls.length ? ' class="' + cls.join(" ") + '"' : "") +
                ">" +
                c.label +
                "</a></li>"
              );
            })
            .join("") +
          "</ul>";
      }

      return (
        '<li class="lyd-hv2-drawer__row"' +
        (hasKids ? ' data-has-subs' : "") +
        ">" +
        main +
        subs +
        "</li>"
      );
    }).join("");

    return (
      '<div class="lyd-hv2-drawer-backdrop" data-lyd-drawer-close hidden></div>' +
      '<aside class="lyd-hv2-drawer" id="lyd-hv2-drawer" role="dialog" aria-modal="true" aria-label="Menü" hidden>' +
      '<div class="lyd-hv2-drawer__head">' +
      '<p class="lyd-hv2-drawer__title">Menü</p>' +
      '<button type="button" class="lyd-hv2-drawer__close" data-lyd-drawer-close aria-label="Menü schließen">' +
      svg('<path d="M18 6L6 18"/><path d="M6 6l12 12"/>') +
      "</button>" +
      "</div>" +
      '<div class="lyd-hv2-drawer__body">' +
      '<ul class="lyd-hv2-drawer__list">' +
      rows +
      "</ul>" +
      "</div>" +
      '<div class="lyd-hv2-drawer__foot">' +
      '<a href="/search" data-lyd-search-open>' +
      svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>') +
      "Suche</a>" +
      '<a href="/account/login">' +
      svg(
        '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'
      ) +
      "Konto</a>" +
      '<a href="/cart" data-no-instant>' +
      svg(
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>'
      ) +
      "Warenkorb</a>" +
      "</div>" +
      "</aside>"
    );
  }

  function wireDropdowns(root) {
    var items = root.querySelectorAll(
      ".lyd-hv2-siteheader__item[data-has-panel]"
    );
    var openTimer = null;
    var closeTimer = null;
    var openItem = null;

    function setExpanded(item, open) {
      var link = item.querySelector(".lyd-hv2-siteheader__link");
      if (link) link.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) item.classList.add("is-open");
      else item.classList.remove("is-open");
    }

    function closeAll(except) {
      items.forEach(function (it) {
        if (it !== except) setExpanded(it, false);
      });
      if (!except) openItem = null;
    }

    function scheduleOpen(item) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () {
        closeAll(item);
        setExpanded(item, true);
        openItem = item;
      }, OPEN_DELAY);
    }

    function scheduleClose(item) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (openItem === item) {
          setExpanded(item, false);
          openItem = null;
        }
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      item.addEventListener("mouseenter", function () {
        scheduleOpen(item);
      });
      item.addEventListener("mouseleave", function () {
        scheduleClose(item);
      });
      item.addEventListener("focusin", function () {
        clearTimeout(closeTimer);
        closeAll(item);
        setExpanded(item, true);
        openItem = item;
      });
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) {
          scheduleClose(item);
        }
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && openItem) {
        setExpanded(openItem, false);
        var link = openItem.querySelector(".lyd-hv2-siteheader__link");
        openItem = null;
        if (link) link.focus();
      }
    });

    document.addEventListener(
      "click",
      function (e) {
        if (!openItem) return;
        if (!openItem.contains(e.target)) {
          setExpanded(openItem, false);
          openItem = null;
        }
      },
      true
    );
  }

  function wireMobileDrawer(root) {
    var burger = root.querySelector("[data-lyd-drawer-open]");
    var drawer = root.querySelector("#lyd-hv2-drawer");
    var backdrop = root.querySelector(".lyd-hv2-drawer-backdrop");
    if (!burger || !drawer) return;

    var lastFocus = null;

    function setOpen(open) {
      if (open) {
        lastFocus = document.activeElement;
        document.body.classList.add("lyd-hv2-nav-open");
        drawer.hidden = false;
        if (backdrop) backdrop.hidden = false;
        burger.setAttribute("aria-expanded", "true");
        // focus close after paint
        requestAnimationFrame(function () {
          var closeBtn = drawer.querySelector("[data-lyd-drawer-close]");
          if (closeBtn) closeBtn.focus();
        });
      } else {
        document.body.classList.remove("lyd-hv2-nav-open");
        burger.setAttribute("aria-expanded", "false");
        // allow transition then hide for a11y
        setTimeout(function () {
          if (!document.body.classList.contains("lyd-hv2-nav-open")) {
            drawer.hidden = true;
            if (backdrop) backdrop.hidden = true;
          }
        }, 280);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }

    burger.addEventListener("click", function () {
      var isOpen = document.body.classList.contains("lyd-hv2-nav-open");
      setOpen(!isOpen);
    });

    root.querySelectorAll("[data-lyd-drawer-close]").forEach(function (el) {
      el.addEventListener("click", function () {
        setOpen(false);
      });
    });

    // Accordion toggles
    drawer.querySelectorAll(".lyd-hv2-drawer__row[data-has-subs]").forEach(function (row) {
      var btn = row.querySelector(".lyd-hv2-drawer__toggle");
      var subs = row.querySelector(".lyd-hv2-drawer__subs");
      if (!btn || !subs) return;
      btn.addEventListener("click", function () {
        var open = !row.classList.contains("is-open");
        // close siblings (optional single-open)
        drawer.querySelectorAll(".lyd-hv2-drawer__row.is-open").forEach(function (other) {
          if (other !== row) {
            other.classList.remove("is-open");
            var ob = other.querySelector(".lyd-hv2-drawer__toggle");
            var os = other.querySelector(".lyd-hv2-drawer__subs");
            if (ob) ob.setAttribute("aria-expanded", "false");
            if (os) os.hidden = true;
          }
        });
        row.classList.toggle("is-open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        subs.hidden = !open;
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && document.body.classList.contains("lyd-hv2-nav-open")) {
        setOpen(false);
      }
    });

    // Close if resizing to desktop
    var mq = window.matchMedia("(min-width: 901px)");
    function onMq(e) {
      if (e.matches) setOpen(false);
    }
    if (mq.addEventListener) mq.addEventListener("change", onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  /* ── Predictive search overlay (command palette) ── */
  var SEARCH_RECENT_KEY = "lyd_hv2_search_recent";
  var SEARCH_SHORTCUTS = [
    { label: "E-Zigaretten", href: "/collections/e-zigaretten" },
    { label: "Nikotinsalz", href: "/collections/nikotinsalz" },
    { label: "Pods", href: "/collections/pods" },
    { label: "Liquids", href: "/collections/liquids" },
    { label: "Sale", href: "/collections/sale" },
  ];

  function searchOverlayHtml() {
    return (
      '<div class="lyd-hv2-search" id="lyd-hv2-search" hidden>' +
      '<div class="lyd-hv2-search__bg" data-lyd-search-close></div>' +
      '<div class="lyd-hv2-search__panel" role="dialog" aria-modal="true" aria-label="Suche">' +
      '<form class="lyd-hv2-search__form" action="/search" method="get" role="search">' +
      '<input type="hidden" name="type" value="product">' +
      '<div class="lyd-hv2-search__field">' +
      svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>') +
      '<input class="lyd-hv2-search__input" type="search" name="q" id="lyd-hv2-search-q" placeholder="Produkt, Marke oder Geschmack …" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="search" aria-label="Suchbegriff">' +
      '<kbd class="lyd-hv2-search__kbd" hidden>⌘K</kbd>' +
      '<button type="button" class="lyd-hv2-search__x" data-lyd-search-close aria-label="Suche schließen">×</button>' +
      "</div></form>" +
      '<div class="lyd-hv2-search__body" id="lyd-hv2-search-body"></div>' +
      "</div></div>"
    );
  }

  function escHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatEuro(raw) {
    var n = parseFloat(String(raw == null ? "" : raw).replace(",", "."));
    if (isNaN(n)) return "";
    return n.toFixed(2).replace(".", ",") + "\u00a0€";
  }

  function searchImg(src) {
    if (!src) return "";
    if (/[?&]width=\d+/i.test(src)) return src.replace(/width=\d+/i, "width=160");
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=160";
  }

  function cleanProductUrl(u) {
    try {
      var url = new URL(u, window.location.origin);
      ["_pos", "_psq", "_psid", "_ss"].forEach(function (k) {
        url.searchParams.delete(k);
      });
      return url.pathname + (url.search ? url.search : "");
    } catch (e) {
      return u;
    }
  }

  function readRecent() {
    try {
      var raw = localStorage.getItem(SEARCH_RECENT_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      return arr
        .map(function (x) {
          return String(x || "").trim();
        })
        .filter(Boolean)
        .slice(0, 8);
    } catch (e) {
      return [];
    }
  }

  function saveRecent(term) {
    var t = String(term || "").trim();
    if (!t) return;
    var next = [t].concat(
      readRecent().filter(function (x) {
        return x.toLowerCase() !== t.toLowerCase();
      })
    );
    try {
      localStorage.setItem(SEARCH_RECENT_KEY, JSON.stringify(next.slice(0, 8)));
    } catch (e) {}
  }

  function clearRecent() {
    try {
      localStorage.removeItem(SEARCH_RECENT_KEY);
    } catch (e) {}
  }

  function wireSearch(root) {
    var overlay = root.querySelector("#lyd-hv2-search");
    var input = root.querySelector("#lyd-hv2-search-q");
    var bodyEl = root.querySelector("#lyd-hv2-search-body");
    var form = overlay && overlay.querySelector(".lyd-hv2-search__form");
    var kbd = overlay && overlay.querySelector(".lyd-hv2-search__kbd");
    if (!overlay || !input || !bodyEl || !form) return;

    var openState = false;
    var lastFocus = null;
    var abortCtl = null;
    var debounceT = null;
    var activeIdx = -1;

    var isMac = /Mac|iPhone|iPad/i.test(navigator.platform || "");
    if (kbd && isMac && window.matchMedia("(min-width: 901px)").matches) {
      kbd.hidden = false;
    }

    function hitsEls() {
      return bodyEl.querySelectorAll("[data-lyd-search-hit]");
    }

    function setActive(i) {
      var els = hitsEls();
      if (!els.length) {
        activeIdx = -1;
        return;
      }
      if (i < 0) i = els.length - 1;
      if (i >= els.length) i = 0;
      activeIdx = i;
      els.forEach(function (el, n) {
        el.classList.toggle("is-active", n === i);
      });
      els[i].scrollIntoView({ block: "nearest" });
    }

    function shortcutsHtml() {
      return (
        '<p class="lyd-hv2-search__label">Beliebte Kategorien</p>' +
        '<div class="lyd-hv2-search__chips">' +
        SEARCH_SHORTCUTS.map(function (s) {
          return (
            '<a class="lyd-hv2-search__chip" href="' +
            s.href +
            '">' +
            escHtml(s.label) +
            "</a>"
          );
        }).join("") +
        "</div>"
      );
    }

    function recentHtml() {
      var rec = readRecent();
      if (!rec.length) return "";
      return (
        '<div class="lyd-hv2-search__recent-head">' +
        '<p class="lyd-hv2-search__label">Zuletzt gesucht</p>' +
        '<button type="button" class="lyd-hv2-search__clear" data-lyd-search-clear>löschen</button>' +
        "</div>" +
        '<ul class="lyd-hv2-search__recent">' +
        rec
          .map(function (t) {
            return (
              '<li><button type="button" class="lyd-hv2-search__recent-item" data-lyd-search-term="' +
              escHtml(t) +
              '">' +
              escHtml(t) +
              "</button></li>"
            );
          })
          .join("") +
        "</ul>"
      );
    }

    function renderIdle() {
      activeIdx = -1;
      bodyEl.innerHTML =
        '<div class="lyd-hv2-search__idle">' +
        shortcutsHtml() +
        recentHtml() +
        "</div>";
    }

    function renderLoading() {
      bodyEl.innerHTML =
        '<p class="lyd-hv2-search__status">Suche …</p>';
    }

    function productHit(p) {
      var href = cleanProductUrl(p.url || "/products/" + p.handle);
      var img =
        (p.featured_image && p.featured_image.url) || p.image || "";
      var priceMin = p.price_min || p.price;
      var priceMax = p.price_max || p.price;
      var priceTxt = formatEuro(priceMin);
      if (priceMin && priceMax && String(priceMin) !== String(priceMax)) {
        priceTxt = "ab " + priceTxt;
      }
      var cmp = parseFloat(p.compare_at_price_min || "0");
      var cur = parseFloat(priceMin || "0");
      var cmpHtml =
        cmp > cur && cmp > 0
          ? '<s>' + escHtml(formatEuro(p.compare_at_price_min)) + "</s> "
          : "";
      var stock = p.available
        ? '<span class="is-in">Auf Lager</span>'
        : '<span class="is-out">Ausverkauft</span>';
      var thumb = img
        ? '<img src="' +
          escHtml(searchImg(img)) +
          '" alt="" width="56" height="56" loading="lazy">'
        : "";
      return (
        '<a class="lyd-hv2-search__hit" href="' +
        escHtml(href) +
        '" data-lyd-search-hit data-lyd-search-q="' +
        escHtml(input.value.trim()) +
        '">' +
        '<span class="lyd-hv2-search__thumb">' +
        thumb +
        "</span>" +
        '<span class="lyd-hv2-search__meta">' +
        '<span class="lyd-hv2-search__vendor">' +
        escHtml(p.vendor || "") +
        "</span>" +
        '<span class="lyd-hv2-search__title">' +
        escHtml(p.title || "") +
        "</span>" +
        '<span class="lyd-hv2-search__row">' +
        '<span class="lyd-hv2-search__price">' +
        cmpHtml +
        escHtml(priceTxt) +
        "</span>" +
        stock +
        "</span></span></a>"
      );
    }

    function renderResults(q, products) {
      activeIdx = -1;
      var list = products || [];
      if (!list.length) {
        bodyEl.innerHTML =
          '<p class="lyd-hv2-search__status">Keine Treffer für „' +
          escHtml(q) +
          "“.</p>" +
          '<a class="lyd-hv2-search__all" href="/search?type=product&amp;q=' +
          encodeURIComponent(q) +
          '">Trotzdem suchen</a>' +
          shortcutsHtml();
        return;
      }
      bodyEl.innerHTML =
        '<div class="lyd-hv2-search__hits">' +
        list.map(productHit).join("") +
        "</div>" +
        '<a class="lyd-hv2-search__all" href="/search?type=product&amp;q=' +
        encodeURIComponent(q) +
        '">Alle Treffer für „' +
        escHtml(q) +
        "“</a>";
    }

    function runSuggest(q) {
      if (abortCtl) abortCtl.abort();
      abortCtl = window.AbortController ? new AbortController() : null;
      renderLoading();
      var params = new URLSearchParams();
      params.set("q", q);
      params.set("resources[type]", "product");
      params.set("resources[limit]", "8");
      params.set("resources[options][unavailable_products]", "last");
      fetch("/search/suggest.json?" + params.toString(), {
        credentials: "same-origin",
        signal: abortCtl ? abortCtl.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error("suggest");
          return r.json();
        })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          var products =
            (data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];
          renderResults(q, products);
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          bodyEl.innerHTML =
            '<p class="lyd-hv2-search__status">Suche gerade nicht erreichbar.</p>' +
            '<a class="lyd-hv2-search__all" href="/search?type=product&amp;q=' +
            encodeURIComponent(q) +
            '">Zur Suchseite</a>';
        });
    }

    function onQuery() {
      var q = input.value.trim();
      if (debounceT) clearTimeout(debounceT);
      if (q.length < 2) {
        if (abortCtl) abortCtl.abort();
        renderIdle();
        return;
      }
      debounceT = setTimeout(function () {
        runSuggest(q);
      }, 200);
    }

    function openSearch(prefill) {
      if (openState) {
        input.focus();
        return;
      }
      if (document.body.classList.contains("lyd-hv2-nav-open")) {
        var closeBtn = root.querySelector("[data-lyd-drawer-close]");
        if (closeBtn) closeBtn.click();
      }
      lastFocus = document.activeElement;
      openState = true;
      overlay.hidden = false;
      overlay.classList.add("is-open");
      document.body.classList.add("lyd-hv2-search-open");
      if (typeof prefill === "string") input.value = prefill;
      if (input.value.trim().length >= 2) runSuggest(input.value.trim());
      else renderIdle();
      requestAnimationFrame(function () {
        input.focus();
        if (input.value) input.select();
      });
    }

    function closeSearch() {
      if (!openState) return;
      openState = false;
      overlay.classList.remove("is-open");
      overlay.hidden = true;
      document.body.classList.remove("lyd-hv2-search-open");
      if (abortCtl) abortCtl.abort();
      if (debounceT) clearTimeout(debounceT);
      if (lastFocus && lastFocus.focus) {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
    }

    root.addEventListener("click", function (e) {
      var openEl = e.target.closest("[data-lyd-search-open]");
      if (openEl) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        openSearch();
        return;
      }
      if (e.target.closest("[data-lyd-search-close]")) {
        e.preventDefault();
        closeSearch();
        return;
      }
      if (e.target.closest("[data-lyd-search-clear]")) {
        e.preventDefault();
        clearRecent();
        renderIdle();
        return;
      }
      var termBtn = e.target.closest("[data-lyd-search-term]");
      if (termBtn) {
        e.preventDefault();
        input.value = termBtn.getAttribute("data-lyd-search-term") || "";
        input.focus();
        onQuery();
        return;
      }
      var hit = e.target.closest("[data-lyd-search-hit]");
      if (hit) {
        saveRecent(hit.getAttribute("data-lyd-search-q") || input.value);
      }
    });

    form.addEventListener("submit", function (e) {
      var q = input.value.trim();
      if (!q) {
        e.preventDefault();
        return;
      }
      saveRecent(q);
    });

    input.addEventListener("input", onQuery);

    document.addEventListener("keydown", function (e) {
      var metaK = (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey && (e.key === "k" || e.key === "K");
      if (metaK) {
        var tag = (e.target && e.target.tagName) || "";
        var typing =
          tag === "INPUT" ||
          tag === "TEXTAREA" ||
          tag === "SELECT" ||
          (e.target && e.target.isContentEditable);
        if (typing && e.target !== input) return;
        e.preventDefault();
        if (openState) input.focus();
        else openSearch();
        return;
      }

      if (!openState) return;

      if (e.key === "Escape") {
        e.preventDefault();
        closeSearch();
        return;
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActive(activeIdx + 1);
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActive(activeIdx < 0 ? 0 : activeIdx - 1);
        return;
      }
      if (e.key === "Enter" && activeIdx >= 0 && e.target === input) {
        var els = hitsEls();
        if (els[activeIdx]) {
          e.preventDefault();
          els[activeIdx].click();
        }
      }
    });
  }

  function buildChrome() {
    if (document.getElementById(ROOT_ID)) return;

    var root = document.createElement("div");
    root.id = ROOT_ID;
    root.className = "lyd-hv2-chrome-root";

    var trustItems = [
      {
        icon: '<path d="M20 6L9 17l-5-5"/>',
        text: "Über 300.000 Kunden",
      },
      {
        icon:
          '<rect x="1" y="6" width="15" height="12" rx="2"/><path d="M16 10h4l3 3v5h-7"/><circle cx="6" cy="18" r="1.6"/><circle cx="19" cy="18" r="1.6"/>',
        text: "Versandkostenfrei ab 50 €",
      },
      {
        icon: '<path d="M12 2l2.9 6.9L22 9.2l-5 4.9 1.2 7L12 17.8 5.8 21.1 7 14.1 2 9.2l7.1-.3L12 2z" fill="currentColor" stroke="none"/>',
        text: "9.601 Bewertungen · Ø 4,9 · Okendo",
      },
      {
        icon: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>',
        text: "030 568 380 65",
      },
    ];

    var trustHtml =
      '<div class="lyd-hv2-trustbar" id="lyd-hv2-trustbar" role="region" aria-label="Shop-Vorteile">' +
      '<div class="lyd-hv2-trustbar__inner">' +
      trustItems
        .map(function (it) {
          return (
            '<span class="lyd-hv2-trustbar__item">' +
            svg(it.icon) +
            it.text +
            "</span>"
          );
        })
        .join("") +
      "</div></div>";

    var navHtml = NAV.map(navItemHtml).join("");

    var icons =
      '<div class="lyd-hv2-siteheader__icons">' +
      '<a href="/search" aria-label="Suche" data-lyd-search-open>' +
      svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>') +
      "</a>" +
      '<a href="/account/login" aria-label="Konto">' +
      svg(
        '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'
      ) +
      "</a>" +
      '<a href="/cart" aria-label="Warenkorb" data-no-instant>' +
      svg(
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>'
      ) +
      "</a>" +
      "</div>";

    var burger =
      '<button type="button" class="lyd-hv2-siteheader__burger" data-lyd-drawer-open aria-expanded="false" aria-controls="lyd-hv2-drawer" aria-label="Menü öffnen">' +
      '<span class="lyd-hv2-siteheader__burger-icon" aria-hidden="true"></span>' +
      "</button>";

    var headerHtml =
      '<header class="lyd-hv2-siteheader" role="banner">' +
      '<div class="lyd-hv2-siteheader__wrap">' +
      burger +
      logoHtml() +
      '<nav class="lyd-hv2-siteheader__nav" aria-label="Hauptnavigation">' +
      navHtml +
      "</nav>" +
      icons +
      "</div></header>";

    var quickNavHtml =
      '<nav class="lyd-hv2-quicknav" aria-label="Kategorien">' +
      '<div class="lyd-hv2-quicknav__track">' +
      MOBILE_QUICK_NAV.map(function (item) {
        var cls =
          "lyd-hv2-quicknav__chip" +
          (item.sale ? " is-sale" : "") +
          (item.tool ? " is-tool" : "");
        return (
          '<a class="' +
          cls +
          '" href="' +
          item.href +
          '">' +
          item.label +
          "</a>"
        );
      }).join("") +
      "</div></nav>";

    root.innerHTML =
      trustHtml + headerHtml + quickNavHtml + drawerHtml() + searchOverlayHtml();

    if (document.body) {
      document.body.insertBefore(root, document.body.firstChild);
    }

    wireDropdowns(root);
    wireMobileDrawer(root);
    wireSearch(root);
  }

  /**
   * HV2 mockup footer — replaces Impact footer group.
   * Legal / about links must match live shop pages (not Shopify policy URLs).
   */
  function buildFooter() {
    if (document.getElementById("lyd-hv2-footer")) return;
    if (!document.body) return;

    var year = new Date().getFullYear();
    var footer = document.createElement("footer");
    footer.id = "lyd-hv2-footer";
    footer.className = "lyd-hv2-footer";
    footer.setAttribute("role", "contentinfo");
    footer.innerHTML =
      '<div class="lyd-hv2-footer__wrap lyd-hv2-footer__cols">' +
      "<div>" +
      '<div class="lyd-hv2-footer__logo">LYNDEN</div>' +
      '<p class="lyd-hv2-footer__about">' +
      "Premium E-Zigaretten, Liquids und Depots. Deutsche Marke mit Sitz in Berlin — seit über 10 Jahren. Beratung: " +
      '<a href="tel:+493056838065" style="display:inline;color:inherit;text-decoration:underline">030 568 380 65</a>' +
      "</p>" +
      "</div>" +
      "<div>" +
      "<h4>Über uns</h4>" +
      '<a href="/pages/dein-e-zigaretten-shop">Über LYNDEN</a>' +
      '<a href="/pages/versand-zahlungsinformationen">Versand &amp; Zahlung</a>' +
      '<a href="/pages/kontakt">Kontakt</a>' +
      '<a href="/pages/impressum-lynden">Impressum</a>' +
      '<a href="/pages/presse">Presse</a>' +
      "</div>" +
      "<div>" +
      "<h4>Informationen</h4>" +
      '<a href="/pages/liquidrechner">Liquid-Rechner</a>' +
      '<a href="/blogs/e-zigaretten-blog">E-Zigaretten Blog</a>' +
      '<a href="/pages/faq">FAQ</a>' +
      '<a href="/pages/glossar-e-zigarette">Glossar</a>' +
      '<a href="/pages/lynden-recycling">Recycling</a>' +
      '<a href="/pages/jugendschutz">Jugendschutz</a>' +
      '<a class="lyd-wr-footer-link" href="/pages/vertrag-widerrufen">Vertrag widerrufen</a>' +
      "</div>" +
      '<div class="lyd-hv2-footer__oke">' +
      "<h4>Kundenbewertungen</h4>" +
      '<div class="lyd-hv2-footer__oke-badge" data-oke-badge data-oke-layout="large" data-oke-color-scheme="dark"></div>' +
      "</div>" +
      "</div>" +
      '<div class="lyd-hv2-footer__sub">' +
      '<div class="lyd-hv2-footer__wrap">' +
      "© " +
      year +
      " LYNDEN" +
      ' · <a href="/pages/datenschutzerklarung">Datenschutz</a>' +
      ' · <a href="/pages/impressum-lynden">Impressum</a>' +
      ' · <a href="/pages/agb">AGB</a>' +
      ' · <a href="/pages/widerrufsrecht">Widerrufsbelehrung</a>' +
      ' · <a class="lyd-wr-footer-link" href="/pages/vertrag-widerrufen">Vertrag widerrufen</a>' +
      "</div></div>";

    document.body.appendChild(footer);
    // Okendo scans for [data-oke-badge] after dynamic insert
    try {
      if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === "function") {
        window.okeWidgetApi.initAllWidgets();
      } else if (window.okeReviews && typeof window.okeReviews.init === "function") {
        window.okeReviews.init();
      }
    } catch (e) {}
  }

  function boot() {
    mark();
    buildChrome();
    buildFooter();
    hideImpactChrome();
  }

  mark();
  ready(boot);
  document.addEventListener("shopify:section:load", boot);
})();
